<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Transfer Management</h1>
    <transferSubDistrict/>
  </v-card>
</template>

<script>
import transferSubDistrict from "@/components/back-office/Transfer/TransferSubDistrict";
export default {
  components: {
    transferSubDistrict
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Food delivery",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/food/promotion"
      },
      {
        text: "Transfer sub district",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
</style>